import { languageSelector } from "@omni/ui/components/LanguageSelector/languageSelector.styles";
import { cn } from "@omni/utils/styles";

import { LanguageListItem } from "@/components/General/LanguageSelector/layouts/list/listItem.component";
import { Config } from "@/utils/config.utils";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";

import { LanguageSelectorComponentProps } from "../../languageSelector.types";

const LanguageListSelector = ({
    variant,
    color
}: LanguageSelectorComponentProps) => {
    const clientSide = useIsClientSide();

    if (!clientSide) return null;

    return (
        <div className={languageSelector({ class: "tw:my-1", color })}>
            <ul className={cn("tw:m-0 tw:p-0 tw:list-none")}>
                {Config.languages.map((language) => (
                    <li
                        className={cn(
                            "tw:block tw:py-1 tw:px-5 tw:first:pt-3 tw:last:pb-3"
                        )}
                        key={language["language-code"]}
                    >
                        <LanguageListItem
                            language={language}
                            isCurrent={
                                language.locale === Config.general.locale
                            }
                            variant={variant}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default LanguageListSelector;
